import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    gameState: '',
    gameUpdate: false,
    currentChapter: 0,
    currentTimer: 0,
    currentDuration: 0,
    username: '',
    teamname: '',
    languageChoosen: false
  },
  getters: {
    gameState: state => state.gameState,
    gameUpdate: state => state.gameUpdate
  },
  mutations: {
    updateGameState (state, gameState) {
      Vue.set(state, 'gameState', gameState)
    },
    reloadGameData (state, bool) {
      state.gameUpdate = bool
    },
    updateCurrentChapter (state, payload) {
      state.currentChapter = payload.chapter
      state.currentTimer = payload.timer
      state.currentDuration = payload.duration
    },
    setCurrentChapter (state, chapter) {
      state.currentChapter = chapter
    },
    setCurrentTimer (state, timer) {
      state.currentTimer = timer
    },
    setUsername (state, username) {
      state.username = username
    },
    setTeamname (state, teamname) {
      state.teamname = teamname
    },
    languageSelected (state) {
      state.languageChoosen = true
      state.gameUpdate = true
    },
    loggedIn (state) {
      state.gameUpdate = true
    }
  },
  actions: {
  },
  modules: {
  }
})
